import translator from '@Components/Utilities/Translator';
import { useState, useRef } from 'react';
import Toggle from '@Components/Shared/Controls/Toggle';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import Button from '@mui/material/Button';
import EmailAlertsTextAlertModal from '@Components/Shared/Modals/EmailAlertsTextAlertModal';
import { gtmAlertPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType, registrationNotificationTypes } from '@Components/Utilities/SandhillsConstants';
import { smsType } from '@Components/Utilities/SandhillsConstants';
import  SelectField  from '@Components/Shared/Controls/SelectField';

const AlertPreferences = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const routes = useRecoilValue(atoms.routes);
    const [isSaleCatalogUploadAlertModal, setIsSaleCatalogUploadAlertModal] = useState(props.IsModal && props.EventID ? true : false);
    const [mainNotificationsSection, setMainNotificationsSection] = useState(() => {
        if (isSaleCatalogUploadAlertModal) {
            return props.AuctionAlertPreferences.filter(x => x.Name === translator.translate('sandhills.tradepubwebsite.mvc.aneventhasstarted'));
        } else {
            return props.AuctionAlertPreferences.filter(x => x.Name !== translator.translate('sandhills.autoposttofr8starshippingquotes') && x.Name !== translator.translate('sandhills.catalogisuploaded'));
        }
    });
    const [emailOnlyNotifications, setEmailOnlyNotifications] = useState(props.AuctionAlertPreferences.filter(x => !isSaleCatalogUploadAlertModal && x.Name === translator.translate('sandhills.autoposttofr8starshippingquotes')));
    const [saleCatalogUploadNotifications, setSaleCatalogUploadNotifications] = useState(props.AuctionAlertPreferences.filter(x => !isSaleCatalogUploadAlertModal && x.Name === translator.translate('sandhills.catalogisuploaded')));
    const [saleCatalogUploadNotificationForModal, setSaleCatalogUploadNotificationForModal] = useState(() => {
        var existingPreference = props.AuctionAlertPreferences.filter(x => isSaleCatalogUploadAlertModal && x.Name === translator.translate('sandhills.catalogisuploaded') && x.EventID == props.EventID);

        if (existingPreference == null || existingPreference.length == 0) {
            // If the user has not signed up for catalog alerts for this event before, we need to get the base preference
            return [{
                Name: translator.translate('sandhills.catalogisuploaded'),
                NotificationTypeID: registrationNotificationTypes.CatalogUploaded,
                NotificationType: Object.keys(registrationNotificationTypes).find(key => registrationNotificationTypes[key] === registrationNotificationTypes.CatalogUploaded),
                SiteId: currentSite.SiteID,
                EventID: props.EventID
            }];
        }

        return existingPreference;
    });
    const [emailsChecked, setEmailsChecked] = useState([props.AuctionAlertPreferences.filter(c => c.EmailEnabled)]);
    const [textsChecked, setTextsChecked] = useState([props.AuctionAlertPreferences.filter(c => c.TextEnabled)]);
    const [showTextAlertForm, setShowTextAlertForm] = useState(false);
    const [showTextAlertHeader, setShowTextAlertHeader] = useState(props.TextAlertModel.AlertsEnabled);
    const [signUpPreference, setSignUpPreference] = useState(false);
    const [smsPhone, setSMSPhone] = useState(props.TextAlertModel.PhoneNumber);
    const [auctionEventAlertTime, setAuctionEventAlertTime] = useState(props.AuctionEventAlertNotificationTimePreference);
    // Confirmation modal states
    const [showPhoneConfirmation, setShowPhoneConfirmation] = useState(false);
    const [phoneConfirmationCheckFailed, setPhoneConfirmationCheckFailed] = useState(false);
    const [showDeletePhoneConfirmation, setShowDeletePhoneConfirmation] = useState(false);
    const [phoneSubscribedSuccess, setPhoneSubscribedSuccess] = useState(false);
    const [phoneRemovedSuccess, setPhoneRemovedSuccess] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);

    const intlTelInput = useRef(null);
    const [textAlertModel, setTextAlertModel] = useState(props.TextAlertModel);

    const toggleEmail = (event) => {
        event.EmailEnabled = !event.EmailEnabled;
        setEmailsChecked([...emailsChecked, event]);
    }

    const toggleText = (event) => {
        event.TextEnabled = !event.TextEnabled;
        setTextsChecked([...textsChecked, event]);
    }

    const toggleEmailAndSaveChange = (event) => {
        event.EmailEnabled = !event.EmailEnabled;
        saveSingleAlertPref(event, "Email");
    }
    const toggleTextAndChange = (event) => {
        event.TextEnabled = !event.TextEnabled;
        saveSingleAlertPref(event, "Text");
    }

    const saveSingleAlertPref = (changedAlert, TextOrEmail) => {

        let bSigningUp = TextOrEmail === "Text" ? changedAlert.TextEnabled : changedAlert.EmailEnabled;

        gtmAlertPushEvent(bSigningUp ? gtmEventType.alertToggleOn : gtmEventType.alertToggleOff, 'AlertType', changedAlert.NotificationType, 'DeviceType', TextOrEmail);

        sandhillsRequest({
            url: routes.SaveAlertPreference,
            method: 'post',
            data: {
                AlertPreference: changedAlert,
                DeviceType: TextOrEmail === "Text" ? 'Mobile_Phone' : 'Email',
                NotificationSettingsTab: props.AccountMenu?.ActiveTab
            }
        }).then((data) => {
            TextOrEmail === "Text" ? setTextsChecked([]) : setEmailsChecked([]);            
        })


    }

    const closeTextAlertModal = (e) => {
        setShowTextAlertForm(false);
        setShowDeletePhoneConfirmation(false);
        setPhoneConfirmationCheckFailed(false);
        setShowPhoneConfirmation(false);
        setTextAlertModel(previousState => {
            return {
                ...previousState,
                PhoneNumber: smsPhone
            };
        });
    }

    const showTextAlertModal = () => {
        setShowTextAlertForm(true);
    }

    const checkPhoneConfirmation = () => {
        setDisableSubmit(true);
        let formattedPhone = intlTelInput.current?.getNumber();
        sandhillsRequest({
            url: routes.CheckShowSMSPhoneUpdateConfirmation,
            method: 'post',
            data: {
                smsPhone: formattedPhone,
                smsSignUpTypeID: smsType.auctionAlerts
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((response) => {
            if (response.showConfirmation) {
                setDisableSubmit(false);
                setShowPhoneConfirmation(true);
            } else {
                saveAuctionTextAlert();
            }
        }).catch((error) => {
            console.log(error);
            setDisableSubmit(false);
            setPhoneConfirmationCheckFailed(true);
        });
    }

    const submitAuctionTextAlert = (subscribe, skipPhoneConfirmationCheck) => {
        setPhoneConfirmationCheckFailed(false);
        if (subscribe) {
            skipPhoneConfirmationCheck ? saveAuctionTextAlert() : checkPhoneConfirmation();
        }
        else {
            toggleAlertsEnabled();
        }
    }

    const saveAuctionTextAlert = () => {
        setDisableSubmit(true);

        setTextAlertModel(previousState => {
            return {
                ...previousState,
                PhoneNumber: intlTelInput.current?.getNumber(intlTelInputUtils?.numberFormat.INTERNATIONAL),
                ISOCountryAbbreviation: intlTelInput.current?.selectedCountryData.iso2 ?? 'US'
            };
        });

        sandhillsRequest({
            url: routes.SaveEmailAlertsTextAlert,
            method: 'post',
            data: textAlertModel,
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((data) => {
            setDisableSubmit(false);
            setShowPhoneConfirmation(false);
            setPhoneSubscribedSuccess(true);

            setTextAlertModel(previousState => {
                return {
                    ...previousState,
                    alertsEnabled: data
                };
            });
            if (data) {
                setSMSPhone(textAlertModel.PhoneNumber);
                setShowTextAlertHeader(true);
                if (signUpPreference) {
                    if (props.IsModal) {
                        toggleText(signUpPreference);
                    }
                    else {
                        toggleTextAndChange(signUpPreference);
                    }
                    setSignUpPreference();
                }
            }
            setTimeout(() => {
                setPhoneSubscribedSuccess(false);
                setShowTextAlertForm(false);
            }, 2500);
        });
    }
    const onChange = (e) => {
        setTextAlertModel(previousState => {
            return {
                ...previousState,
                PhoneNumber: intlTelInput.current?.getNumber(intlTelInputUtils?.numberFormat.INTERNATIONAL) ?? e.target.value,
                ISOCountryAbbreviation: intlTelInput.current?.selectedCountryData.iso2 ?? 'US'
            };
        });
    }
    const onChangeAuctionEventAlertNotificationTime = (e) => {
        let eventAlertTime = e.target.value;

        sandhillsRequest({
            url: routes.UpdateAuctionEventNotificationSettings,
            method: 'post',
            data: {
                eventAlertTime: eventAlertTime 
            },
        }).then((response) => {
                setAuctionEventAlertTime(eventAlertTime);
        }).catch((error) => {
                console.log('Error saving Event Alert Notification Time: ', error);
                window.location.reload(true);
        });

    }
    const showDeletePhoneConfirmationModal = () => {
        setShowDeletePhoneConfirmation(true);
        setShowTextAlertForm(true);
    }

    const toggleAlertsEnabled = () => {
        setDisableSubmit(true);

        sandhillsRequest({
            url: routes.TurnOffTextAlerts,
            method: 'post',
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((data) => {
            setDisableSubmit(false);
            setPhoneRemovedSuccess(true);
            setShowDeletePhoneConfirmation(false);
            setTextAlertModel(previousState => {
                return {
                    ...previousState,
                    alertsEnabled: !data
                };
            });
            setTimeout(() => {
                setPhoneRemovedSuccess(false);
                setShowTextAlertForm(false);
                setDisableSubmit(false);
                setShowDeletePhoneConfirmation(false);
            }, 2500);
            setShowTextAlertHeader(false);
            setMainNotificationsSection[mainNotificationsSection]
        });
    }

    return (
        <>
            <div className='alert-preferences'>
                {showTextAlertHeader &&
                    <div className='text-alert-header'>
                        <div>
                            {textAlertModel.AlertsEnabled ?
                                translator.translate('sandhills.tradesites.mvc.youaresigneduptoreceivetextalerts').replace('{0}', smsPhone)
                                : translator.translate('sandhills.tradesites.mvc.stopreceivingtexts').replace('{0}', smsPhone)}
                        </div>
                        <a role='button' tabIndex='0' onClick={showDeletePhoneConfirmationModal} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {e.preventDefault(); showDeletePhoneConfirmationModal() } }}>
                            <strong>{translator.translate('sandhills.tradesites.mvc.turnofftextalerts')}</strong>
                        </a>&nbsp;&nbsp;<a role='button' tabIndex='0' onClick={showTextAlertModal} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {e.preventDefault(); showTextAlertModal() } }}>
                            <strong>{translator.translate('sandhills.tradesites.mvc.editphonenumber')}</strong></a>
                        <br />
                        <span className='blurb-section' dangerouslySetInnerHTML={{ __html: props.TextAlertBlurb }} />
                    </div>
                }

                {isSaleCatalogUploadAlertModal && saleCatalogUploadNotificationForModal.length > 0 &&
                    <>
                        <div className='alert-preference-title uppercase'>{translator.translate('sandhills.tradesites.mvc.addreminderforevent')}</div>
                        <div className='alert-preference-section'>
                            <div className='alert-preference-top'>
                                <div className='helper-text'><strong>{translator.translate('sandhills.sendmeanalertwhen')}</strong></div>
                                <div className='alert-title'>{translator.translate('sandhills.crm.dscrm.text')}</div>
                                <div className='alert-title'>{translator.translate('sandhills.email')}</div>
                            </div>
                            <div className='alert-preferences-preferences-display'>
                                <div className='helper-text'><label htmlFor={saleCatalogUploadNotificationForModal[0].NotificationType + '-watchlist'}>{saleCatalogUploadNotificationForModal[0].Name}</label></div>
                                <div className='alert-title'>
                                    {showTextAlertHeader ?
                                        <>
                                            <div className='toggle'>
                                                <Toggle
                                                    classNames='closest-toggle'
                                                    id={saleCatalogUploadNotificationForModal[0].NotificationType + '-watchlist'}
                                                    IsChecked={saleCatalogUploadNotificationForModal[0].TextEnabled}
                                                    onChange={(e) => toggleTextAndChange(saleCatalogUploadNotificationForModal[0])}
                                                /></div>
                                        </>
                                        :
                                        <>
                                        <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showTextAlertModal(); } }} className='link' onClick={showTextAlertModal}><strong>{translator.translate('sandhills.signup')}</strong></div>
                                        </>
                                    }
                                </div>
                                <div className='alert-title'>
                                    <div className='toggle'>
                                        <Toggle
                                            classNames='closest-toggle'
                                            id={saleCatalogUploadNotificationForModal[0].NotificationType + '-watchlist'}
                                            IsChecked={saleCatalogUploadNotificationForModal[0].EmailEnabled}
                                            onChange={(e) => toggleEmailAndSaveChange(saleCatalogUploadNotificationForModal[0])}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                <div className='alert-preference-section'>
                    <div className='alert-preference-top'>
                        <div className='helper-text'><strong>{translator.translate('sandhills.tradepubwebsite.mvc.sendmewatchlistalertwhen')}</strong></div>
                        <div className='alert-title'>{translator.translate('sandhills.crm.dscrm.text')}</div>
                        <div className='alert-title'>{translator.translate('sandhills.email')}</div>
                    </div>
                    <div className='alert-preferences-preferences-display'>
                        {mainNotificationsSection?.map((mainPrefs, index) => {
                            return (
                                <>
                                    <div className='helper-text'>
                                        <label htmlFor={mainPrefs.NotificationType + '-watchlist'}>{mainPrefs.Name}</label>
                                        {mainPrefs.NotificationTypeID == registrationNotificationTypes.AuctionStarts &&
                                                <SelectField
                                                    name='event-alert-select'
                                                    id='event-alert-select'
                                                    class='event-alert-time'
                                                    options={props.AuctionEventAlertNotificationTimes}
                                                    value={auctionEventAlertTime}
                                                    selectClass='select-dropdown'
                                                    onFieldChanged={onChangeAuctionEventAlertNotificationTime}
                                                    label={mainPrefs.Name}
                                                    hideLabel={true}
                                                />
                                        }
                                    </div>

                                    <div className='alert-title'>
                                        {showTextAlertHeader ?
                                            <>
                                                <div className='toggle'>
                                                    <Toggle
                                                        classNames='closest-toggle'
                                                        id={mainPrefs.NotificationType + '-watchlist'}
                                                        IsChecked={mainPrefs.TextEnabled}
                                                        onChange={(e) => toggleTextAndChange(mainPrefs)}
                                                    /></div>
                                            </>
                                            :
                                            <>
                                                <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showTextAlertModal(); } }} className='link' onClick={showTextAlertModal}><strong>{translator.translate('sandhills.signup')}</strong></div>
                                            </>
                                        }
                                    </div>
                                    <div className='alert-title'>
                                        <div className='toggle'>
                                            <Toggle
                                                classNames='closest-toggle'
                                                id={mainPrefs.NotificationType + '-watchlist'}
                                                IsChecked={mainPrefs.EmailEnabled}
                                                onChange={(e) => toggleEmailAndSaveChange(mainPrefs)}
                                            /></div>
                                    </div>
                                </>
                            )
                        })}
                    </div>
                </div>

                {!props.IsModal && props.AccountMenu?.ActiveTab == "EquipmentFacts" && saleCatalogUploadNotifications.length > 0 &&
                    <div className='alert-preference-section'>
                        <div className='alert-preference-top'>
                            <div className='helper-text'><strong>{translator.translate('sandhills.eventswithcataloguploadalerts')}</strong></div>
                            <div className='alert-title'>{translator.translate('sandhills.crm.dscrm.text')}</div>
                            <div className='alert-title'>{translator.translate('sandhills.email')}</div>
                        </div>
                        <div className='alert-preferences-preferences-display'>
                            {saleCatalogUploadNotifications?.map((eventPrefs) => {
                                return (
                                    <>
                                        <div className='helper-text'>
                                            <a htmlFor={eventPrefs.NotificationType + '-watchlist'} href={eventPrefs.SaleCatalogURL}>
                                                {eventPrefs.AuctioneerName} - {eventPrefs.EventTitle}
                                            </a>
                                            &nbsp;
                                            <i className='fas fa-up-right-from-square' />
                                        </div>
                                        <div className='alert-title'>
                                            {showTextAlertHeader ?
                                                <>
                                                    <div className='toggle'>
                                                        <Toggle
                                                            classNames='closest-toggle'
                                                            id={eventPrefs.NotificationType + '-watchlist'}
                                                            IsChecked={eventPrefs.TextEnabled}
                                                            onChange={(e) => toggleTextAndChange(eventPrefs)}
                                                        /></div>
                                                </>
                                                :
                                                <>
                                                    <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showTextAlertModal(); } }} className='link' onClick={showTextAlertModal}><strong>{translator.translate('sandhills.signup')}</strong></div>
                                                </>
                                            }
                                        </div>
                                        <div className='alert-title'>
                                            <div className='toggle'>
                                                <Toggle
                                                    classNames='closest-toggle'
                                                    id={eventPrefs.NotificationType + '-watchlist'}
                                                    IsChecked={eventPrefs.EmailEnabled}
                                                    onChange={(e) => toggleEmailAndSaveChange(eventPrefs)}
                                                /></div>
                                        </div>
                                    </>
                                )
                            })}
                        </div>
                    </div>
                }
                
                {emailOnlyNotifications.length > 0 &&
                    <div className='alert-preference-title uppercase'> {translator.translate('sandhills.interestedinsigningupforothersitealerts').replace("{0}", props.AccountMenu?.ActiveTab ?? (currentSite.CurrentSite == 'BidCaller' ? 'EquipmentFacts' : currentSite.CurrentSite))}</div>}
                {emailOnlyNotifications.length > 0 &&
                    <div className='alert-preference-section'>
                        <div className='alert-preference-top'>
                            <div className='helper-text'><strong>{translator.translate('sandhills.requestshippingestimate')}</strong></div>
                            <div className='alert-title'></div>
                            <div className='alert-title capitalize'>{translator.translate('sandhills.on')} / {translator.translate('sandhills.off')}</div>
                        </div>
                        <div className='alert-preferences-preferences-display'>
                            {emailOnlyNotifications?.map((emailOnlyPref, index) => {
                                return (
                                    <>
                                        <div className='helper-text'><label htmlFor={emailOnlyPref.NotificationType + '-watchlist'}>{emailOnlyPref.Name}</label></div>
                                        <div className='alert-title'>
                                        </div>
                                        <div className='alert-title'>
                                            <div className='toggle'>
                                                <Toggle
                                                    classNames='closest-toggle'
                                                    id={emailOnlyPref.NotificationType + '-watchlist'}
                                                    IsChecked={emailOnlyPref.EmailEnabled}
                                                    onChange={(e) => toggleEmailAndSaveChange(emailOnlyPref)}
                                                />
                                            </div>
                                        </div>
                                        {emailOnlyPref.LegalText.length > 0 &&
                                            <div className='alert-pref-legal'>{emailOnlyPref.LegalText}</div>
                                        }
                                    </>
                                )
                            })}
                        </div>
                    </div>
                }

                {showTextAlertForm &&
                    <EmailAlertsTextAlertModal
                        onClose={closeTextAlertModal}
                        onChange={onChange}
                        textAlertEnterNumberText={props.TextAlertEnterNumberText}
                        textAlertOptOutText={props.TextAlertOptOutText}
                        smsPhoneUpdateConfirmationText={props.SMSPhoneUpdateConfirmationText}
                        smsPhoneRemovalConfirmationText={props.SMSPhoneRemovalConfirmationText}
                        onSubmit={submitAuctionTextAlert}
                        modalInfo={textAlertModel}
                        disableSubmit={disableSubmit}
                        phoneSubscribedSuccess={phoneSubscribedSuccess}
                        phoneRemovedSuccess={phoneRemovedSuccess}
                        intlTelInput={intlTelInput}
                        showPhoneConfirmation={showPhoneConfirmation}
                        showDeletePhoneConfirmation={showDeletePhoneConfirmation}
                        currentSMSPhone={smsPhone}
                        displayError={phoneConfirmationCheckFailed}
                    />
                }
            </div>

            {props.IsModal && !isSaleCatalogUploadAlertModal &&
                <>
                    <Button className='submit' onClick={props.onClose}>{translator.translate('sandhills.tradepubwebsite.mvc.submit')}</Button>
                </>}

        </>
    )
}
export default AlertPreferences;